import React from "react";
import { Container } from "react-bootstrap";

function EmptyFooter (props) {
  
    return (
      <footer className="footer px-0 px-lg-3">
        <Container fluid>
          <nav>
            <ul className="footer-menu">
              <li>
                &nbsp;
              </li>
              
              
            </ul>
            <p className="copyright text-center">
              © {new Date().getFullYear()}{" "}
               copyright&nbsp;<a href="mailto:info@benevare.com?subject=Info Request">&nbsp;Benevare Inc.</a>
            </p>
          </nav>
        </Container>
      </footer>
    );
}

export default EmptyFooter;
